module.exports = __webpack_public_path__ + "static/media/metabolomic-diagnostics.97f7dbc5.jpg";